import React from "react";
import {
  ActionButton,
} from "../ResultsPrimitives.jsx";
import { formatTonsWithUnit } from "../../utils/resultsFleetData.js";

const summaryPillClass = "flex min-w-0 items-center gap-1.5 rounded-[4px] border border-line-soft bg-white px-2 py-1 text-xs font-medium text-text";
const summaryLabelClass = "shrink-0 text-[0.64rem] uppercase tracking-[0.16em] text-muted-strong";

export default function ReassignmentPopoverHeader({
  isLoading,
  isRouteImpactPending,
  modeToggleDisabled,
  modeToggleLabel,
  onClose,
  onToggleRouteImpact,
  resolvedContexts,
  resolvedStep,
  showRouteImpact,
  stepLabel,
}) {
  const hasSingleContext = resolvedContexts.length === 1;
  const primaryContext = hasSingleContext ? resolvedContexts[0] : null;
  const orderId = primaryContext?.order_id ?? resolvedStep?.order_id ?? null;
  const quantityLabel = formatTonsWithUnit(
    primaryContext?.quantity_tons ?? resolvedStep?.quantity_tons,
    { fallback: null },
  );
  const sourceTruckLabel = hasSingleContext
    ? primaryContext?.current_truck_name
      ?? primaryContext?.current_truck_id
      ?? resolvedStep?.assignment_truck_name
      ?? resolvedStep?.assignment_truck_id
      ?? null
    : null;
  const loadingClientName = primaryContext?.loading_client_name
    ?? resolvedStep?.loading_client_name
    ?? (resolvedStep?.step_type === "loading" ? resolvedStep?.client_name : null)
    ?? null;
  const destinationClientName = resolvedStep?.step_type === "delivery"
    ? resolvedStep?.client_name ?? null
    : primaryContext?.client_name ?? null;
  const hasRouteSummary = Boolean(loadingClientName || destinationClientName);
  const headerPills = [
    sourceTruckLabel
      ? {
        key: "source-truck",
        label: "Camion actuel",
        value: sourceTruckLabel,
      }
      : null,
    orderId
      ? {
        key: "order-id",
        value: `Commande: ${orderId}`,
      }
      : null,
    quantityLabel
      ? {
        key: "quantity",
        value: quantityLabel,
      }
      : null,
  ].filter(Boolean);

  return (
    <header className="border-b border-line-soft bg-surface px-3.5 py-2 lg:px-4 lg:py-2">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2 gap-y-1.5">
            <h2 className="font-display text-lg font-semibold leading-tight text-text lg:text-xl">
              Réaffectation camion
            </h2>
            {headerPills.map((pill) => (
              <div key={pill.key} className={[summaryPillClass, "max-w-full"].join(" ")}>
                {pill.label ? (
                  <span className={summaryLabelClass}>{pill.label}</span>
                ) : null}
                <span className="min-w-0 break-words font-medium text-text">
                  {pill.value}
                </span>
              </div>
            ))}
          </div>
          <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-strong">
            {loadingClientName ? (
              <span>
                <span className="font-semibold text-text">Chargement</span>{" "}
                <span>{loadingClientName}</span>
              </span>
            ) : null}
            {destinationClientName ? (
              <span>
                <span className="font-semibold text-text">Déchargement</span>{" "}
                <span>{destinationClientName}</span>
              </span>
            ) : null}
            {!hasRouteSummary ? (
              <span className="font-semibold text-text">
                {stepLabel}
              </span>
            ) : null}
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <ActionButton
            tone="subtle"
            size="sm"
            isLoading={isRouteImpactPending}
            loadingLabel="Calcul des impacts..."
            className={[
              "min-h-9 px-3 py-2 text-sm shadow-none",
              showRouteImpact
                ? "border-accent bg-accent text-white hover:border-accent-strong hover:bg-accent-strong"
                : "border-border-warning-subtle bg-amber-soft text-warning-ink hover:border-border-warning-muted hover:bg-white hover:text-warning-ink",
            ].join(" ")}
            onClick={onToggleRouteImpact}
            disabled={modeToggleDisabled || isLoading}
          >
            {modeToggleLabel}
          </ActionButton>
          <ActionButton
            tone="subtle"
            size="sm"
            className="shrink-0 shadow-none"
            onClick={() => onClose?.()}
          >
            Fermer
          </ActionButton>
        </div>
      </div>
    </header>
  );
}
